import { Name4 } from "../../ui/ot";
const Z3950DocumentResponse2 = ({
    ...props
}) => {


    return (
        <Name4
            dbCoverIdName="z3950_document_id"
            propsCategoryName="建立"
            propsCategoryTitle="內容"
            mainApiRoute="/cataloging/backend/z3950_document/view"
            formColumnApi="/client_management/backend/client/form"
            createMode="page"
        />

    )
}
export default Z3950DocumentResponse2
